import * as React from "react";
import { observer, inject } from "mobx-react";
import { hashHistory } from "react-router";
import SeekerStore from "../../../stores/seekerStore";
import { OpportunitySummary } from "../../../models/opportunity";
import { IOpDetailLocalization } from "../../../models/localization";
import { Grid, Row, Col } from "react-flexbox-grid";
import OpportunitySummaryCard from "../opSummary";
import * as s from "./relatedOps.css";

@inject("store") @observer
export default class RelatedOps extends React.Component<{ store: SeekerStore }, {}> {
  constructor(props: any) {
    super(props);
  }
  renderRelatedOps(): JSX.Element {
      let cards: JSX.Element[] = [];
      this.props.store.opportunityStore.relatedOps.map((os: OpportunitySummary, i: number): void => {
        cards.push(<OpportunitySummaryCard key={i} store={this.props.store} op={os} />);
      });
      return <Row className={s.relatedOpRow}>{cards}</Row>
  }
  render(): JSX.Element {
      if (this.props.store.opportunityStore.relatedOps.length === 0) {
          return null;
      }
    const opLocal:IOpDetailLocalization = this.props.store.localization.fields.opDetail;
    return (<div><h5 className={s.header}>{opLocal.relatedOps}</h5>
        {this.renderRelatedOps()}</div>)
  }
}


// WEBPACK FOOTER //
// ./src/components/opportunity/relatedOps/index.tsx